import http from '../../../http'
import { API_URL } from '../../../const'
import { IComponentTaxonomyCreatePayload, IComponentTaxonomyUpdatePayload } from './types'

const BASE_URL = `${API_URL}/Taxonomy/PackagingComponent`

export const getComponentTaxonomy = (id: number) => http.get(`${BASE_URL}/component/${id}`)

export const createComponentTaxonomy = (data: IComponentTaxonomyCreatePayload) =>
  http.post(`${BASE_URL}/component`, { data })

export const updateComponentTaxonomy = (data: IComponentTaxonomyUpdatePayload) =>
  http.put(`${BASE_URL}/component`, { data })

export const publishComponentTaxonomy = (id: number) =>
  http.post(`${BASE_URL}/component/publish/${id}`)

export const unpublishComponentTaxonomy = (id: number) =>
  http.delete(`${BASE_URL}/component/unpublish/${id}`)

export const getComponentTaxonomyConfiguration = (id?: number) =>
  http.get(`${BASE_URL}/component/configuration/${id ?? 0}`)
